// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"697":"news","893":"products"}[chunkId] + "." + {"697":"4f31a0f2","893":"657ceed2"}[chunkId] + ".css";
};